<template>
  <div class="ml-3">
    <validation-observer v-if="!isReadOnly" ref="requestItemRef">
      <div v-if="isAddMode || isEmpty" class="row bg-secondary-13 p-3 rounded">
        <div class="col">
          <div class="text-center">
            <action-button
              v-if="!isAddMode && isEmpty"
              class="border w-40"
              i="fas fa-plus-square color-primary-1"
              text="Presione aquí para documentar los servicios compensatorios"
              @click="isAddMode = !isAddMode"
            />
          </div>
          <div v-if="isAddMode">
            <div class="row">
              <div class="col-md-4">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="editModel.visitAbsenceReasonId"
                    custom-error-msg="Razón de ausencia es requerida"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Razón de la Ausencia:"
                    :options="repositionReasons"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div class="col-md-4">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-input
                    v-model="editModel.visitDue"
                    custom-error-msg="Cantidad de intervenciones adeudadas es requerida"
                    :error="errors[0]"
                    label="Cantidad de Intervenciones Adeudadas:"
                    :max="4"
                    :min="1"
                    type="number"
                  />
                </validation-provider>
              </div>
              <div
                class="col-md-4 d-flex justify-content-center align-items-center pt-4"
              >
                <action-button
                  i="fas fa-times-circle"
                  variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
                  @click="onCloseHandler"
                >
                  Cancelar
                </action-button>
                <action-button
                  i="fas fa-save"
                  variant="success pl-4 pr-4"
                  @click="onAddHandler"
                >
                  Guardar
                </action-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
    <div class="mt-2">
      <div
        v-for="(item, index) in value"
        :key="`service-item-${index}`"
        class="row bg-secondary-13 p-3 mb-2 rounded"
      >
        <div class="col-md-4">
          <div class="font-weight-normal font-14 color-secondary-6">
            Razón de la Ausencia:
          </div>
          <span class="font-weight-normal font-16 color-black">
            {{ item.visitAbsenceReasonName }}
          </span>
        </div>
        <div class="col-md-4">
          <div class="font-weight-normal font-14 color-secondary-6">
            Cantidad de Intervenciones Adeudadas:
          </div>
          <span
            v-if="!isEditMode"
            class="font-weight-normal font-16 color-black"
          >
            {{ item.visitDue }}
          </span>
          <custom-input
            v-if="isEditMode"
            v-model="dueInterventions[index]"
            custom-error-msg="Es requerido entrar las intervenciones que se adeudan."
            type="number"
            :value="item.visitDue"
          />
        </div>
        <div
          v-if="
            isReadOnly && !isEditMode && hasUpdateDueInterventionsPermissions
          "
          class="col-md-4 text-right pt-1"
        >
          <action-button
            i="fas fa-edit"
            variant="outline-success btn-cancel success"
            @click="openEditMode(index, item.visitDue)"
          >
            Editar
          </action-button>
        </div>
        <div v-if="isEditMode" class="col-md-4 text-right pt-1">
          <action-button
            i="fas fa-times"
            variant="outline-danger btn-cancel danger"
            @click="isEditMode = false"
          >
            Cancelar
          </action-button>
          <action-button
            i="fas fa-save"
            variant="outline-success btn-cancel success"
            @click="updateDueInterventions(item.id, index)"
          >
            Guardar
          </action-button>
        </div>

        <div v-if="!isReadOnly" class="col-md-4 text-right pt-1">
          <action-button
            i="fas fa-times-circle"
            variant="outline-danger btn-cancel danger"
            @click="deleteHandler(index)"
          >
            Eliminar
          </action-button>
        </div>
      </div>
    </div>
    <div v-if="!isEmpty" class="row bg-gray-4 rounded p-2 mt-1">
      <div class="col-md-4 text-center">
        <span class="color-secondary-6 font-weight-normal font-14">
          Total de Servicios Adeudados:
        </span>
      </div>
      <div class="col-md-4">
        <span>{{ itemCount }}</span>
      </div>
    </div>
    <div v-if="!isReadOnly" class="d-flex justify-content-end mt-2">
      <action-button
        v-if="!isEmpty"
        i="fas fa-file-plus"
        variant="success pl-4 pr-4"
        @click="isAddMode = !isAddMode"
      >
        Añadir
      </action-button>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import alertMixin from 'utils/mixins/alert.mixin.js';

export default {
  name: 'RequestList',
  mixins: [alertMixin],
  components: {
    CustomDropDown,
    ActionButton,
    CustomInput,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    repositionReasons: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    hasUpdateDueInterventionsPermissions: {
      type: Boolean,
      default: false,
    },
    onUpdateDueInterventions: {
      type: Function,
      default: () => Promise.resolve({}),
    },
  },
  data: () => ({
    isEditMode: false,
    isAddMode: false,
    editModel: {
      visitAbsenceReasonId: null,
      visitDue: 0,
    },
    reasons: [],
    dueInterventions: [],
  }),
  computed: {
    itemCount() {
      if (Array.isArray(this.value))
        return this.value
          .map((x) => x.visitDue)
          .reduce((c, n) => c + (n || 0), 0);
      return 0;
    },
    isEmpty() {
      return this.value?.length === 0;
    },
  },
  methods: {
    openEditMode(index, value) {
      this.dueInterventions[index] = value;
      this.isEditMode = true;
    },
    updateDueInterventions(id, index) {
      this.onUpdateDueInterventions(id, this.dueInterventions[index]);
      this.isEditMode = false;
    },
    deleteHandler(index) {
      this.value.splice(index, 1);

      this.ShowToast(
        'Proceso Exitoso',
        'La razón del servicio compensatorio ha sido eliminado exitosamente.',
        'success'
      );
    },
    onCloseHandler() {
      this.isAddMode = false;
      this.onClearModel();
    },
    onClearModel() {
      this.isAddMode = false;
      this.editModel = {};
    },
    async onAddHandler() {
      const isValid = await this.$refs.requestItemRef.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta.', 'error');
        return;
      }

      const isAdded =
        this.value.filter(
          (x) =>
            x.visitAbsenceReasonId === this.editModel.visitAbsenceReasonId?.id
        ).length > 0;
      if (isAdded) {
        this.value.map((x) => {
          if (
            x.visitAbsenceReasonId === this.editModel.visitAbsenceReasonId?.id
          ) {
            x.visitDue = parseInt(this.editModel.visitDue);
          }
        });

        this.onClearModel();
        return;
      }

      this.value.push({
        visitAbsenceReasonId: this.editModel.visitAbsenceReasonId?.id,
        visitAbsenceReasonName: this.editModel.visitAbsenceReasonId?.name,
        visitDue: parseInt(this.editModel.visitDue || 0),
      });

      this.onClearModel();

      this.ShowToast(
        'Proceso Exitoso',
        'La razón del servicio compensatorio ha sido añadido exitosamente.',
        'success'
      );
    },
  },
};
</script>
